import axios from './axiosConfig';
import { User, CreateUserDTO, UpdateUserDTO, ChangePasswordDTO } from '../types/user.types';

const BASE_URL = '/users';

// Get all users
export const getAllUsers = async (): Promise<User[]> => {
  const response = await axios.get<User[]>(BASE_URL);
  return response.data;
};

// Get all representatives
export const getRepresentatives = async (): Promise<User[]> => {
  const response = await axios.get<User[]>(`${BASE_URL}/representatives`);
  return response.data;
};

// Get user by ID
export const getUser = async (id: string): Promise<User> => {
  const response = await axios.get<User>(`${BASE_URL}/${id}`);
  return response.data;
};

// Create user
export const createUser = async (userData: CreateUserDTO): Promise<User> => {
  const response = await axios.post<User>(BASE_URL, userData);
  return response.data;
};

// Update user
export const updateUser = async (id: string, userData: UpdateUserDTO): Promise<User> => {
  const response = await axios.put<User>(`${BASE_URL}/${id}`, userData);
  return response.data;
};

// Delete user
export const deleteUser = async (id: string): Promise<void> => {
  await axios.delete(`${BASE_URL}/${id}`);
};

// Reset user password
export const resetPassword = async (id: string): Promise<void> => {
  await axios.post(`${BASE_URL}/${id}/reset-password`);
};

// Change user password
export const changePassword = async (id: string, data: ChangePasswordDTO): Promise<void> => {
  await axios.post(`${BASE_URL}/${id}/change-password`, data);
};